import type { Locale, SubmissionRecord } from '../../types.js';
import { tx } from '../../ui/shared.js';

export function incidentStateLabel(state: NonNullable<SubmissionRecord['incident']>['state'], locale: Locale): string {
  if (state === 'unassigned') return tx(locale, "ui.records.unassigned.578b7e2e");
  if (state === 'in_progress') return tx(locale, "ui.records.inProgress.80b04ab3");
  if (state === 'resolved') return tx(locale, "ui.records.resolved.07e0ae59");
  return tx(locale, "ui.records.archived.e8b6e166");
}

export function IncidentStatus({ record, locale }: { record: SubmissionRecord; locale: Locale }) {
  const incident = record.incident;
  if (!incident) return null;
  return <span className={`status incident-${incident.state}`}>{incidentStateLabel(incident.state, locale)}{incident.assigneeEmail ? ` · ${incident.assigneeEmail}` : ''}</span>;
}
